import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
};
